<div class="d-flex align-items-center container-title" >
  @if (!isRdsExterno) {
    <div class="container-title-button">
      <button class="btn-back text-center"
        efxTooltip
        efxTooltipTitle="Atrás"
        efxTooltipPlacement="top"
        efxTooltipMode="dark"
        >
        <span class="material-symbols-outlined ms-1 cursor-pointer" (click)="goBack()">
          arrow_back_ios
        </span>
      </button>
    </div>
  }
  <div class="container-title-text">{{ titleText || titleRouter }}</div>
</div>
